/**
 * Dexie offline feature flags (Phase 0).
 * Schema upgrades are always applied; flags only gate UI / sync behavior.
 * Toggle via localStorage key `inventree_offline_flags` (JSON partial override) for rollout.
 */

const DEFAULTS = {
    /** Phase 2 — validated Echo apply layer */
    safeRealtimeApply: true,
    /** Phase 6 — list seed / sync for branches, purchases, suppliers, customers */
    listStoresSync: true,
    /** Phase 7 — detail cache helpers + offline detail views */
    offlineDetailViews: true,
    /** Phase 4 — OfflineNotice + mutation UI/route/HTTP gates */
    readOnlyOfflineUx: true,
    /**
     * Spike — replay convergence from the server change feed instead of the
     * per-table watermark sync. Off until the two are shown to agree; the
     * server half is gated independently by services.offline_sync.change_feed.
     */
    changeFeedSync: false,
    /**
     * Membership reconciliation: checksum verification after each convergence,
     * and manifest-driven eviction of rows that left the reader's scope. Safe
     * with or without the change feed — it repairs what any delta path misses.
     */
    subscriptionReconcile: true,
    /**
     * Warm pos_catalog with the branch's popular/recent variants whenever the POS
     * resolves a branch — which covers both opening the screen and switching
     * branch on it — so an offline till is not limited to what someone searched.
     */
    posWorkingSetPrefetch: true,
};

function loadOverrides() {
    try {
        const raw = localStorage.getItem('inventree_offline_flags');
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

const overrides = typeof localStorage !== 'undefined' ? loadOverrides() : {};

export const offlineFeatureFlags = {
    ...DEFAULTS,
    ...overrides,
};

export function isOfflineFlagEnabled(key) {
    return Boolean(offlineFeatureFlags[key]);
}

export default offlineFeatureFlags;
